import { Button } from "antd";
import { logOut } from "src/util/Commom";
import logo from "../assets/images/logoQTIdata.png";
import "src/styles/login.css";

function LogoImage() {
  return <img src={logo} alt="QTI" title="QTI" />;
}
const Forbidden = () => {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        background: "#F5F5F5"
      }}
    >
      <div className="custom-login" style={{ padding: "20px" }} >
        <div className="gx-login-content">
          <div className="gx-login-header">{LogoImage()}</div>
          <div className="gx-mb-4">
            <h2 style={{ fontSize: "20px" }}>Đăng nhập không hợp lệ!</h2>
            <p>Tài khoản của bạn chưa được cấp quyền để vào ứng dụng này.</p>
            <p>Liên hệ sales@qti.vn để nhận được hỗ trợ.</p>
          </div>
          <Button onClick={() => logOut()}>Đăng xuất</Button>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
